<template>
  <div v-title :data-title="title" v-if="bgLayout === 'center'" class="center-login-container" :style="{ 'background-image': `url(${settingData.bgImage})` }">
    <!-- 蓝色风格一 -->
    <div class="logo"><img src="../../assets/images/logo-block.png"/></div>
    <div class="center-login-content">
      <section class="center-login-box" :style="{ 'border-color': settingData.inputBorderColor }">
        <p class="center-login-title" :style="{ 'color': settingData.fontColor }"><img src="../../assets/images/logo.png" style="margin-right: 15px;margin-top: -10px;"/>{{ $t('loginPage.tysfglpt') }}</p>
        <p class="center-login-scan">
          <svg class="icon" aria-hidden="true" v-show="loginTypeShow" @click="loginTypeShow = !loginTypeShow, loginShow = true, doShowDdQRCode()" :style="{ 'color': settingData.buttonColor }">
            <use xlink:href="#icon-mimadenglu1"></use>
          </svg>
          <svg class="icon" aria-hidden="true" v-show="!loginTypeShow" @click="loginTypeShow = !loginTypeShow, loginShow = true, updatePasswordShow = false, mobileShow = false" :style="{ 'color': settingData.buttonColor }">
            <use xlink:href="#icon-erweima1"></use>
          </svg>
        </p>
        <section v-show="loginShow">
          <div class="center-login-tab" :style="{ 'color': settingData.fontColor }">
          </div>

          <section class="center-login-form center-login-form-align" v-show="!loginTypeShow">
            <section class="center-login-align">
              <div class="center-login-form-input" :style="{ 'border-color': settingData.inputBorderColor }">
                <span class="input-icon">
                  <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
                    <use xlink:href="#icon-kejiyonghu"></use>
                  </svg>
                </span>
                <input v-model="loginFormValidate.userName" class="input-self" :placeholder="$t('loginPage.yhmygbh')" type="text" :style="{ 'color': settingData.fontColor }"/>
              </div>
              <div class="center-login-form-input" :style="{ 'border-color': settingData.inputBorderColor }">
                <span class="input-icon">
                  <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
                    <use xlink:href="#icon-kejimima"></use>
                  </svg>
                </span>
                <input v-model="loginFormValidate.userPassword" class="input-self" :placeholder="$t('loginPage.mm')" type="password" :style="{ 'color': settingData.fontColor }"/>
              </div>
              <p class="forget-password" @click="handleFindPassword" :style="{ 'color': settingData.fontColor }">{{ $t('loginPage.wjmm') }}</p>
              <div class="center-login-range">
                <div class="special-button" :class="rangeStatus ? 'success' : ''" :style="{ 'color': settingData.fontColor, 'background-color': rangeStatus ? settingData.buttonColor : settingData.inputBorderColor }">
                  <span class="special-slide-block" :style="{ 'background-color': settingData.buttonColor }"></span>
                  <span @mousedown.self="rangeMove" class="special-button-block" :style="{ 'background-color': settingData.slideButtonColor }">
                  </span>
                  <span class="special-slide-text">{{ rangeStatus ? $t('loginPage.yzcg') : $t('loginPage.xyhddl') }}</span>
                </div>
              </div>
            </section>
          </section>

          <section class="center-login-form" v-show="loginTypeShow">
            <div class="center-login-qrcode">
              <div id="QRCode" v-show="isScanActive === 'wx'" style="width:290px;height:315px;overflow: hidden;"></div>
              <div id="QRCodedd" v-show="isScanActive === 'dd'" style="height:315px;"></div>
              <div id="QRCodefs" v-show="isScanActive === 'lark'" style="height:315px;"></div>
            </div>
            <p class="qrcode-type">
              <span :active="isScanActive === 'dd'" @click="handleScan('dd')" :style="{ 'color': isScanActive === 'dd' ? settingData.fontColor : '#666' }">{{ $t('loginPage.ddsm') }}</span>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <span :active="isScanActive === 'wx'" @click="handleScan('wx')" :style="{ 'color': isScanActive === 'wx' ? settingData.fontColor : '#666' }">{{ $t('loginPage.qywxsm') }}</span>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <span :active="isScanActive === 'lark'" @click="handleScan('lark')" :style="{ 'color': isScanActive === 'lark' ? settingData.fontColor : '#666' }">{{ $t('loginPage.fssm') }}</span>
            </p>
          </section>
        </section>

        <update-password v-show="updatePasswordShow" :forgetData="forgetData" :updateType="updateType" :userInfo="userInfo" @on-back="onBack" @on-success="onSuccessUpdate"></update-password>

        <mobile-verify v-show="mobileShow"  :mobileList="mobileList" :forgetData="forgetData" :userInfo="userInfo" :loginFormValidate="loginFormValidate" :type="mobileShowType" @on-back="onBack" @on-update-pwd="onUpdatePwd" @on-forget-password="onForgetpwd"></mobile-verify>
      </section>
      <div class="center-login-link" @click="doJumpExternalLinks" :style="{ 'color': settingData.fontColor }">&gt;&gt;&gt;&nbsp;{{ $t('loginPage.wbll') }}&nbsp;&lt;&lt;&lt;</div>
      <footer class="center-login-footer"> <a href="https://beian.miit.gov.cn"  target='_blank'>{{ beian.sysLogoTitle.sys_net_msg}}</a> </footer>
    </div>
  </div>
  <!-- 右边风格二 -->
  <div v-title :data-title="title" v-else class="right-login-container2" :style="{ 'background-image': `url(${settingData.bgImage})` }">
    <div class="logo"><img src="../../assets/images/logo-block.png"/></div>
    <div class="right-login-content">
      <div class="right-login-content-blur"></div>
      <section :class="{'right-login-box': true, 'right-login-box-padding': loginTypeShow}" :style="{ 'background-color': settingData.loginBgColor, 'border-color': settingData.inputBorderColor }">
        <p class="right-login-title" :style="{ 'color': settingData.fontColor }"><img src="../../assets/images/logo.png" style="margin-right: 15px;margin-top: -10px;"/>{{ $t('loginPage.tysfglpt') }}</p>
        <p class="right-login-scan">
          <svg class="icon" aria-hidden="true" v-show="loginTypeShow" @click="loginTypeShow = !loginTypeShow, doShowDdQRCode()" :style="{ 'color': settingData.buttonColor }">
            <use xlink:href="#icon-mimadenglu"></use>
          </svg>
          <svg class="icon" aria-hidden="true" v-show="!loginTypeShow" @click="loginTypeShow = !loginTypeShow, updatePasswordShow = false, mobileShow = false" :style="{ 'color': settingData.buttonColor }">
            <use xlink:href="#icon-erweima"></use>
          </svg>
          <span class="scan-tag" :style="{ 'background-color': settingData.loginBgColor }"></span>
        </p>
        <!-- 账号密码登录 -->
        <section class="right-login-form" v-show="!loginTypeShow && !mobileShow && !updatePasswordShow">
          <p class="right-login-form-title" :style="{ 'color': settingData.fontColor }">{{ $t('loginPage.zhdl') }}</p>
          <div class="right-login-form-input" :style="{ 'background-color': settingData.inputBgColor, 'border-color': settingData.inputBorderColor }">
            <span class="input-icon">
              <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
                <use xlink:href="#icon-yonghu"></use>
              </svg>
            </span>
            <input v-model="loginFormValidate.userName" class="input-self" :placeholder="$t('loginPage.yhmygbh')" type="text" :style="{ 'color': settingData.fontColor }"/>
          </div>
          <div class="right-login-form-input" :style="{ 'background-color': settingData.inputBgColor, 'border-color': settingData.inputBorderColor }">
            <span class="input-icon"><Icon size="20" type="ios-lock-outline" :style="{ 'color': settingData.inputBorderColor }"/></span>
            <input v-model="loginFormValidate.userPassword" class="input-self" :placeholder="$t('loginPage.mm')" type="password" :style="{ 'color': settingData.fontColor }"/>
          </div>
          <p class="forget-password" @click="handleFindPassword" :style="{ 'color': settingData.fontColor }">{{ $t('loginPage.wjmm') }}</p>
          <div class="right-login-range">
            <div class="special-button" :class="rangeStatus ? 'success' : ''" :style="{ 'background-color': rangeStatus ? settingData.buttonColor : settingData.inputBorderColor }">
              <span class="special-slide-block" :style="{ 'background-color': settingData.buttonColor }"></span>
              <span @mousedown.self="rangeMove" class="special-button-block" :style="{ 'background-color': settingData.slideButtonColor }">
              </span>
              <span class="special-slide-text">{{ rangeStatus ? $t('loginPage.yzcg') : $t('loginPage.xyhddl') }}</span>
            </div>
          </div>
        </section>

        <section class="right-login-form" v-show="loginTypeShow">
          <!-- <p class="right-login-form-title" :style="{ 'color': settingData.fontColor }">{{ $t('loginPage.smdl') }}</p> -->
          <div class="right-login-qrcode">
            <div id="QRCode" v-show="isScanActive === 'wx'" style="width:290px;height:315px;overflow: hidden;"></div>
            <div id="QRCodedd" v-show="isScanActive === 'dd'" style="height:315px;"></div>
            <div id="QRCodefs" v-show="isScanActive === 'lark'" style="height:315px;"></div>
          </div>
          <p class="qrcode-type">
            <span :active="isScanActive === 'dd'" @click="handleScan('dd')" :style="{ 'color': isScanActive === 'dd' ? settingData.fontColor : '#666' }">{{ $t('loginPage.ddsm') }}</span>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <span :active="isScanActive === 'wx'" @click="handleScan('wx')" :style="{ 'color': isScanActive === 'wx' ? settingData.fontColor : '#666' }">{{ $t('loginPage.qywxsm') }}</span>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <span :active="isScanActive === 'lark'" @click="handleScan('lark')" :style="{ 'color': isScanActive === 'lark' ? settingData.fontColor : '#666' }">{{ $t('loginPage.fssm') }}</span>
          </p>
        </section>

        <update-password v-show="updatePasswordShow" :forgetData="forgetData" :updateType="updateType" :userInfo="userInfo" @on-back="onBack" @on-success="onSuccessUpdate"></update-password>

        <mobile-verify v-show="mobileShow" :mobileList="mobileList" :forgetData="forgetData" :userInfo="userInfo" :loginFormValidate="loginFormValidate" :type="mobileShowType" @on-back="onBack" @on-update-pwd="onUpdatePwd" @on-forget-password="onForgetpwd"></mobile-verify>
      </section>
      <div class="right-login-link" @click="doJumpExternalLinks" :style="{ 'color': settingData.fontColor }">&gt;&gt;&gt;&nbsp;{{ $t('loginPage.wbll') }}&nbsp;&lt;&lt;&lt;</div>
      <footer class="right-login-footer"> <a href="https://beian.miit.gov.cn"  target='_blank'>{{ beian.sysLogoTitle.sys_net_msg}}</a></footer>
    </div>
  </div>
</template>

<script>
import updatePassword from './password'
import mobileVerify from './mobile'
import { session, cookie } from '@/libs/location'
export default {
  components: {
    updatePassword,
    mobileVerify
  },
  data () {
    return {
      title: '',
      updateType: '',
      bgLayout: 'center',
      loginTypeShow: false,
      updatePasswordShow: false,
      loginShow: true,
      mobileShow: false,
      mobileShowType: 'mobile',
      disX: 0,
      rangeStatus: false,
      isScanActive: 'dd',
      loginFormValidate: {
        userName: '',
        userPassword: ''
      },
      mobileList: [],
      forgetData: {},
      userInfo: {}
    }
  },
  computed: {
    settingData () {
      return this.$store.state.settingData
    },
    beian () {
      return this.$store.state.loginData
    }
  },
  watch: {
    isScanActive: {
      handler (val) {
        this.$nextTick(() => {
          this.handleScan(val)
        })
      },
      immediate: true
    }
  },
  created () {
    this.bgLayout = this.$store.state.settingData.bgLayout
    this.title = this.$store.state.loginData.sysLogoTitle.sys_portal_title
    console.log(this.$store.state.settingData, 'settingData')
    console.log(this.$store.state.loginData.dingding, 'loginData')
    console.log(window.location.origin, 'location.href')
  },
  methods: {
    // 打开wx二维码登录
    doShowQRCode () {
      //  encodeURIComponent(`http://www.baidu.com`)
      // let _baseUrl = this.$baseUrl.replace('.yihchina.com', '.yihchina.net')
      let _baseUrl = window.location.origin
      let weixin = this.$store.state.loginData.weixin
      let a
      if (weixin) {
        a = window.WwLogin({
          id: 'QRCode',
          appid: weixin.appid,
          agentid: weixin.agentid,
          redirect_uri: encodeURIComponent(`${_baseUrl}/sso/weiXin/getUserForAutoLogin`),
          state: '',
          width: '270',
          height: '290'
        })
      } else {
        a = window.WwLogin({
          id: 'QRCode',
          appid: this.$appid,
          agentid: this.$agentid,
          redirect_uri: encodeURIComponent(`${_baseUrl}/sso/weiXin/getUserForAutoLogin`),
          state: '',
          width: '270',
          height: '290'
        })
      }
      console.log('微信扫码登录', a)
    },
    // 打开dd二维码登录
    doShowDdQRCode () {
      //  encodeURIComponent(`http://www.baidu.com`)
      // let _baseUrl = this.$baseUrl.replace('.yihchina.com', '.yihchina.net')
      let _baseUrl = window.location.origin
      let dingding = this.$store.state.loginData.dingding
      let a
      let _gotoUrl
      if (dingding) {
        console.log('111111')
        _gotoUrl = encodeURIComponent(`https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${dingding.appid}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${_baseUrl}/sso/dingDing/getUserForAutoLogin`)
      } else {
        console.log('222222')
        _gotoUrl = encodeURIComponent(`https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=dingoaffcv1abgqhnnrelx&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${_baseUrl}/sso/dingDing/getUserForAutoLogin`)
      }
      if (this.bgLayout === 'center') {
        a = window.DDLogin({
          id: 'QRCodedd',
          goto: _gotoUrl,
          style: 'border:none;background-color:#FFFFFF;',
          width: '270',
          height: '310'
        })
      } else {
        a = window.DDLogin({
          id: 'QRCodedd',
          goto: _gotoUrl,
          style: 'border:none;background-color:#FFFFFF;',
          width: '270',
          height: '290'
        })
      }
      let handleMessage = function (event) {
        let origin = event.origin
        // 判断是否来自ddLogin扫码事件。
        if (origin === 'https://login.dingtalk.com') {
          let loginTmpCode = event.data
          // 获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
          window.location = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=dingoa8cqdj2mkis3xlp0n&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${_baseUrl}/sso/dingDing/getUserForAutoLogin&loginTmpCode=${loginTmpCode}`
        }
      }
      if (typeof window.addEventListener !== 'undefined') {
        window.addEventListener('message', handleMessage, false)
      } else if (typeof window.attachEvent !== 'undefined') {
        window.attachEvent('onmessage', handleMessage)
      }
      console.log('dd扫码登录', a)
    },
    // 打开fs二维码登录
    doShowFsQRCode () {
      // let _baseUrl = 'http://127.0.0.1:8090'
      let _baseUrl = window.location.origin
      let lark = this.$store.state.loginData.feishu
      let _gotoUrl
      // if (lark) {
      _gotoUrl = `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=${lark.appid}&redirect_uri=${encodeURI(_baseUrl)}/sso/feiShu/getUserForAutoLogin&response_type=code&state=success_login`
      // } else {
      //   _gotoUrl = `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a6eaae87d231900e&redirect_uri=${encodeURI(_baseUrl)}/sso/feiShu/getUserForAutoLogin&response_type=code&state=success_login`
      // }
      let QRLoginObj
      console.log(_gotoUrl)
      document.getElementById('QRCodefs').innerHTML = ''
      QRLoginObj = window.QRLogin({
        id: 'QRCodefs',
        goto: `${_gotoUrl}`,
        style: 'width: 270px; height: 290px; border:none;background-color:#FFFFFF;'
      })
      let handleMessage = function (event) {
        let origin = event.origin
        if (QRLoginObj.matchOrigin(origin)) {
          let loginTmpCode = event.data
          // console.log(`${_gotoUrl}&tmp_code=${loginTmpCode}`)
          window.location.href = `${_gotoUrl}&tmp_code=${loginTmpCode}`
        }
      }
      if (typeof window.addEventListener !== 'undefined') {
        window.addEventListener('message', handleMessage, false)
      } else if (typeof window.attachEvent !== 'undefined') {
        window.attachEvent('onmessage', handleMessage)
      }

      if (typeof window.addEventListener !== 'undefined') {
        window.addEventListener('message', handleMessage, false)
      } else if (typeof window.attachEvent !== 'undefined') {
        window.attachEvent('onmessage', handleMessage)
      }
      console.log('fs扫码登录', QRLoginObj)
    },
    doJumpExternalLinks () {
      // this.showLinks = !this.showLinks
      let newpage = this.$router.resolve({ name: 'link' })
      window.open(newpage.href, 'ssoexl')
    },
    handleTurnColorRgb (colorStr) {
      // 16进制颜色值的正则
      let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
      // 把颜色值变成小写
      let color = colorStr.toLowerCase()
      if (reg.test(color)) {
        // 如果只有三位的值，需变成六位，如：#fff => #ffffff
        if (color.length === 4) {
          let colorNew = '#'
          for (let i = 1; i < 4; i += 1) {
            colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1))
          }
          color = colorNew
        }
        // 处理六位的颜色值，转为RGB
        let colorChange = []
        for (let i = 1; i < 7; i += 2) {
          colorChange.push(parseInt('0x' + color.slice(i, i + 2)))
        }
        return colorChange
      } else {
        return color
      }
    },
    // 滑块移动
    rangeMove (e) {
      if (!this.loginFormValidate.userName) {
        this.$Message.warning(this.$t('loginPage.yhmbnwk'))
      } else if (!/^[^\s]*$/.test(this.loginFormValidate.userName)) {
        this.$Message.warning(this.$t('loginPage.yhmbnczkg'))
      } else if (!this.loginFormValidate.userPassword) {
        this.$Message.warning(this.$t('loginPage.mmbnwk'))
      } else {
        let ele = e.target
        let startX = e.clientX
        let eleWidth = ele.offsetWidth
        let parentWidth = ele.parentElement.offsetWidth
        let MaxX = parentWidth - eleWidth
        if (this.rangeStatus) { // 不运行
          return false
        }
        document.onmousemove = (e) => {
          let endX = e.clientX
          this.disX = endX - startX
          if (this.disX <= 0) {
            this.disX = 0
          }
          if (this.disX >= MaxX - eleWidth) { // 减去滑块的宽度,体验效果更好
            this.disX = MaxX
          }
          ele.style.transition = '.1s all'
          ele.style.transform = 'translateX(' + this.disX + 'px)'
          document.querySelector('.special-slide-block').style.right = `calc(100% - ${this.disX + 52}px)`
          e.preventDefault()
        }
        document.onmouseup = () => {
          if (this.disX !== MaxX) {
            ele.style.transition = '.5s all'
            ele.style.transform = 'translateX(0)'
            document.querySelector('.special-slide-block').style.right = 'auto'
            // 执行成功的函数
          } else {
            this.rangeStatus = true
            if (this.status) {
              this.$parent[this.status] = true
            }
            // 执行成功的函数
            this.doVerify()
          }
          document.onmousemove = null
          document.onmouseup = null
        }
      }
    },
    doClickButton () {
      if (!this.loginFormValidate.userName) {
        this.$Message.warning(this.$t('loginPage.yhmbnwk'))
      } else if (!/^[^\s]*$/.test(this.loginFormValidate.userName)) {
        this.$Message.warning(this.$t('loginPage.yhmbnczkg'))
      } else if (!this.loginFormValidate.userPassword) {
        this.$Message.warning(this.$t('loginPage.mmbnwk'))
      } else {
        // 执行成功的函数
        this.doVerify()
      }
    },
    // 手机验证后需要修改密码
    onUpdatePwd () {
      this.loginShow = false
      this.mobileShow = false
      this.updatePasswordShow = true
      // 密码过期修改密码
      this.updateType = 'expired'
    },
    doVerify () {
      let reqdata = {
        userCode: this.loginFormValidate.userName,
        password: this.loginFormValidate.userPassword
      }
      this.$request.post('/sso/login/checkUserNameAndPWD', reqdata).then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          // 下一步界面：index：门户首页；mobile：手机验证；updatePwd：修改密码；remind：错误提示信息
          switch (data.nextStep) {
            case 'index':
              // 设置语言和皮肤
              this.$i18n.locale = data.languageSign
              this.$store.dispatch('doChangeSkin', data.skinColor)

              // session.setObject(data.sessionId)
              session.setItem('userInfo', JSON.stringify(data))
              // cookie.setCookie('token', data.sessionId)
              // let car = ['dlcd.dolinkhub.com']
              let car = ['dlcd.dolinkhub.com', 'localhost:8080']
              if (car.indexOf(window.location.host) !== -1) {
                cookie.setCookie(`token${window.document.location.href.split('/')[3]}`, data.sessionId)
              } else {
                cookie.setCookie(`token`, data.sessionId)
              }
              cookie.setCookie('userInfo', JSON.stringify(data))
              this.$router.push({ name: 'home' })
              break

            case 'mobile':
              session.setItem('userInfo', JSON.stringify(data))
              this.mobileShowType = 'mobile'
              this.mobileList = data.mobileList.map(k => { return { mobile: k } })
              this.mobileShow = true
              this.loginShow = false
              this.updatePasswordShow = false
              break

            case 'updatePwd':
              session.setItem('userInfo', JSON.stringify(data))
              // 首次登录，修改初始密码
              this.loginShow = false
              this.mobileShow = false
              this.updatePasswordShow = true
              this.updateType = 'initial'
              break

            default:
              this.rangeStatus = false
              document.querySelector('.special-button-block').style.transform = 'translateX(0)'
              document.querySelector('.special-slide-block').style.right = 'auto'

              this.$Modal.warning({
                title: this.$t('wxts'),
                content: data.message
              })
              break
          }
        } else {
          this.rangeStatus = false
          document.querySelector('.special-button-block').style.transform = 'translateX(0)'
          document.querySelector('.special-slide-block').style.right = 'auto'
        }
      })
    },
    // 切换扫码方式
    handleScan (type) {
      this.isScanActive = type
      switch (type) {
        case 'wx':
          this.doShowQRCode()
          break
        case 'lark':
          this.doShowFsQRCode()
          break
        default:
          this.doShowDdQRCode()
          break
      }
    },
    // 返回登录页
    onBack (type) {
      if (type === 'mobile') {
        // 返回忘记密码页面
        this.handleFindPassword()
      } else {
        this.loginTypeShow = false
        this.loginShow = true
        this.updatePasswordShow = false
        this.mobileShow = false
        this.mobileShowType = ''
        this.rangeStatus = false
        document.querySelector('.special-button-block').style.transform = 'translateX(0)'
        document.querySelector('.special-slide-block').style.right = 'auto'
      }
    },
    // 打开忘记密码弹框
    handleFindPassword () {
      this.loginShow = false
      // this.loginFormValidate.userName = ''
      // this.loginFormValidate.userPassword = ''
      this.updatePasswordShow = false
      this.mobileShow = true
      this.mobileShowType = 'forgetPassword'
    },
    // 忘记密码点击下一步
    onForgetpwd (data) {
      this.mobileShow = false
      this.updatePasswordShow = true
      this.updateType = 'forget'
      this.forgetData = data
    },
    // 登录
    doLogin () {
      let reqdata = {
        userCode: this.loginFormValidate.userName,
        password: this.loginFormValidate.userPassword
      }
      this.$request.post('/sso/login/userLogin', reqdata).then(res => {
        const { code, data, message } = res.data
        if (code === 'OK') {
          this.userInfo = data
          if (data.message && data.message.indexOf('首次登录') !== -1) {
            // 首次登录，修改初始密码
            this.loginShow = false
            this.mobileShow = false
            this.updatePasswordShow = true
            this.updateType = 'initial'
          } else {
            // 设置语言和皮肤
            this.$i18n.locale = data.languageSign
            this.$store.dispatch('doChangeSkin', data.skinColor)

            session.setObject(data.sessionId)
            session.setItem('userInfo', JSON.stringify(data))
            cookie.setCookie('token', data.sessionId)
            cookie.setCookie('userInfo', JSON.stringify(data))
            this.$router.push({ name: 'home' })
            if (data.remindedMessage) {
              this.$Modal.warning({
                title: this.$t('wxts'),
                content: data.remindedMessage
              })
            }
          }
        } else if (code === 'fail') {
          this.rangeStatus = false
          document.querySelector('.special-button-block').style.transform = 'translateX(0)'
          document.querySelector('.special-slide-block').style.right = 'auto'

          this.mobileShow = false
          if (message.indexOf('验证码') !== -1) {
            this.loginShow = false
            this.updatePasswordShow = false
            this.mobileShow = true
            this.mobileShowType = 'mobile'
          }
        }
      })
    },
    // 修改密码成功
    onSuccessUpdate () {
      this.loginShow = true
      this.loginFormValidate.userName = ''
      this.loginFormValidate.userPassword = ''
      this.updatePasswordShow = false
      this.mobileShow = false
      this.forgetData = {}
    }
  }
}
</script>

<style lang="less">
body {
  overflow: hidden;
}
.center-login-form-center {
  display: flex;
  justify-content: center;
}
.center-login-align {
  width: 100%;
}
.center-login-form-align {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 460px;
}
.center-login-container {
  width: 100%;
  height: 100%;
  background: url('../../assets/images/login-center-bg.jpg') center center no-repeat;
  background-size: cover;
  .logo {
    position: absolute;
    left: 60px;
    top: 40px;
    img {
      width: 226px;
    }
  }
  .center-login-content {
    width: 1400px;
    height: 100vh;
    position: relative;
    left: 50%;
    margin-left: -700px;
    display: flex;
    align-items: center;
    justify-content: center;
    .center-login-scan {
      position: absolute;
      right: 0px;
      top: 0px;
      width: 54px;
      height: 54px;
      cursor: pointer;
      .icon {
        color: #C8291D;
        font-size: 54px;
      }
    }
    .scan-tag {
      display: inline-block;
      position: absolute;
      right: 20px;
      top: 16px;
      width: 68px;
      height: 68px;
      transform: rotate(45deg);
      background-color: transparent;
    }
    .center-login-box {
      position: absolute;
      width: 634px;
      height: 640px;
      margin: 0 auto;
      background-color: rgba(255, 255, 255, .2);
      border-radius: 6px;
      padding: 0 88px;
      border: 1px solid;
      border-color: #00A9FF;
      .center-login-title {
        // position: absolute;
        // left: 0;
        // right: 0;
        text-align: center;
        // top: -86px;
        font-size: 36px;
        margin-top: 55px;
        color: #FFFFFF;
        line-height: 1;
      }
      .center-login-tab {
        padding: 32px 40px;
        padding-top: 0;
        padding-bottom: 45px;
        color: #FFFFFF;
        text-align: center;
        span {
          // flex: 1;
          font-size: 20px;
          text-align: center;
          position: relative;
          cursor: pointer;
          &:first-child {
            margin-right: 72px;
          }
          &[active] {
            font-size: 26px;
            // font-weight: bold;
            .active {
              display: inline-block;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 104px;
              height: 12px;
              background-color: blue;
              opacity: .5;
            }
          }
        }
      }
      .center-login-form {
        .center-login-form-title {
          display: flex;
          margin-top: 48px;
          margin-bottom: 32px;
          font-size: 20px;
          color: #FFFFFF;
          line-height: 37px;
          .icon {
            flex: 0 0 46px;
            text-align: center;
            line-height: 37px;
            color: #00A7FF;
            cursor: pointer;
            // margin-right: 24px;
          }
          span {
            flex: 1;
            padding-left: 12px;
          }
          small {
            flex: 1;
            padding-left: 12px;
            font-size: 20px;
            font-weight: 400;
          }
        }
        .center-login-form-input {
          width: 100%;
          background: rgba(255, 255, 255, .2);
          border: 1px solid;
          border-color: #073DBE;
          border-radius: 4px;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          height: 54px;
          margin-bottom: 24px;
          padding-right: 16px;
          .input-icon {
            // flex: 0 0 52px;
            color: #073DBE;
            padding: 0 16px;
            box-sizing: border-box;
          }
          .input-self {
            flex: 1;
            border: none;
            outline: none;
            box-shadow: none;
            background-color: transparent;
            font-size: 18px;
            line-height: 28px;
            color: #FFFFFF;
            min-width: 100px;
          }
        }
        .forget-password {
          text-align: right;
          font-size: 18px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 1;
          margin-bottom: 24px;
          cursor: pointer;
        }
        .center-login-button {
          box-shadow: none;
          background-color: #00A8FE;
          width: 100%;
          height: 54px;
          border-radius: 4px;
          line-height: 54px;
          font-size: 18px;
          color: #FFFFFF;
          margin-bottom: 70px;
          position: relative;
          cursor: pointer;
        }
        .special-button {
          height: 54px;
          overflow: hidden;
          margin-bottom: 70px;
          // 输入框边框颜色
          background-color: #00A8FE;
          position: relative;
          transition: 1s all;
          user-select: none;
          // 字体颜色
          color: #FFFFFF;
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          &.success{
            background-color: #073DBE;
            color: #fff;
          }
          .special-button-block {
            position: absolute;
            z-index: 99;
            padding: 4px;
            top: 0;
            left: 0;
            bottom: 0;
            width: 52px;
            color: #fff;
            background-color: #073DBE;
            background-clip: content-box;
            cursor: pointer;
            font-size: 24px;
            display: flex;
            justify-content: center;
            align-items: center;
            &::after {
              content: '>>';
              color: #fff;
              font-size: 14px;
            }
          }
        }
      }
    }
    .center-login-link {
      font-size: 18px;
      color: #FFFFFF;
      position: absolute;
      bottom: 80px;
      left: 0;
      right: 0;
      text-align: center;
      cursor: pointer;
    }
    .center-login-footer {
      cursor: pointer;
      position: absolute;
      left: 0;
      right: 0;
      text-align: center;
      bottom: 40px;
      text-align: center;
      font-size: 14px;
      color: #999999;
    }
    .center-login-qrcode {
      width: 405px;
      height: 435px;
      margin: 32px auto;
      margin-top: 0;
      background-color: transparent;
      background-clip: content-box;
      display: flex;
      align-items: center;
      justify-content: center;
      // padding: 8px;
      border-radius: 4px;
      position: relative;
      // overflow: hidden;
      #QRCode {
        height: 100%;
        width: 100%;
        margin: 0 auto;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
        iframe {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0px;
          left: 0px;
        }
      }
      #QRCodedd {
        height: 100%;
        width: 100%;
        margin: 0 auto;
        position: relative;
        text-align: center;
        iframe {
          background: #fff;
        }
      }
      &[expired] {
        background-color: #FFFFFF;
        opacity: .8;
      }
      .expired-code {
        p {
          font-size: 14px;
          font-weight: 500;
          color: #333333;
          line-height: 20px;
        }
        .refresh-code {
          margin: 0 auto;
          margin-top: 8px;
          width: 98px;
          height: 31px;
          line-height: 31px;
          font-size: 13px;
          color: #FFFFFF;
          background: #00A8FE;
        }
      }
    }
    .qrcode-type {
      position: absolute;
      bottom: -28px;
      text-align: center;
      font-size: 18px;
      color: #666666;
      line-height: 25px;
      cursor: pointer;
      left: 0;
      margin-bottom: 40px;
      width: 634px;
      span {
        &[active] {
          color: #FFFFFF;
        }
      }
    }
  }
  .center-login-content2 {
    width: 1400px;
    height: 100vh;
    position: relative;
    left: 50%;
    margin-left: -700px;
    display: flex;
    align-items: center;
    justify-content: center;
    .logo {
      position: absolute;
      left: 60px;
      top: 40px;
      img {
        width: 126px;
      }
    }
    .center-login-box {
      background: transparent;
      padding: 0 24px;
      border-radius: 10px;
      text-align: center;
      position: absolute;
      width: 1124px;
      height: 615px;
      margin: 0 auto;
      .center-login-title {
        margin-top: 4vh;
        text-align: center;
        font-size: 50px;
        color: #FFFFFF;
        line-height: 1;
      }
      .center-login-tab {
        padding: 32px 40px;
        padding-top: 0px;
        padding-bottom: 45px;
        color: #FFFFFF;
        text-align: center;
        span {
          // flex: 1;
          font-size: 20px;
          text-align: center;
          position: relative;
          cursor: pointer;
          &:first-child {
            margin-right: 72px;
          }
          &[active] {
            font-size: 24px;
            // font-weight: bold;
            .active {
              display: inline-block;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 104px;
              height: 12px;
              background-color: blue;
              opacity: .5;
            }
          }
        }
      }
      .center-login-form {
        position: relative;
        .center-login-form-center {
          display: flex;
          justify-content: center;
        }
        // overflow: hidden;
        .center-login-form-title {
          display: flex;
          margin-top: 48px;
          margin-bottom: 32px;
          font-size: 20px;
          color: #FFFFFF;
          line-height: 37px;
          .icon {
            flex: 0 0 46px;
            text-align: left;
            line-height: 37px;
            color: #00A7FF;
            cursor: pointer;
          }
          small {
            flex: 1;
            padding-left: 12px;
            font-size: 20px;
            font-weight: 400;
          }
        }
        .center-login-form-input {
          position: relative;
          width: 260px;
          float: left;
          background: rgba(255, 255, 255, .2);
          border: 1px solid;
          border-color: #073DBE;
          border-radius: 26px;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          height: 44px;
          margin-bottom: 24px;
          padding-right: 16px;
          margin-right: 12px;
          .input-icon {
            color: #073DBE;
            padding: 0 16px;
          }
          .input-self {
            flex: 1;
            max-width: 200px;
            border: none;
            outline: none;
            box-shadow: none;
            background-color: transparent;
            font-size: 18px;
            line-height: 28px;
            color: #FFFFFF;
            min-width: 100px;
          }
        }
        .forget-password {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 18px;
          text-decoration: underline;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 1;
          margin-bottom: 24px;
          cursor: pointer;
        }
        .center-login-button {
          float: left;
          box-shadow: none;
          background-color: #00A8FE;
          width: 260px;
          height: 44px;
          border-radius: 26px;
          line-height: 44px;
          font-size: 18px;
          color: #FFFFFF;
          margin-bottom: 70px;
          position: relative;
          cursor: pointer;
        }
        .center-login-range {
          width: 260px;
          float: left;
        }
        .special-button {
          overflow: hidden;
          margin-bottom: 70px;
          // 输入框边框颜色
          background-color: #00A8FE;
          border-radius: 26px;
          position: relative;
          transition: 1s all;
          user-select: none;
          // 字体颜色
          color: #FFFFFF;
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 44px;
          &.success{
            background-color: #073DBE;
            color: #fff;
          }
          .special-button-block {
            position: absolute;
            z-index: 99;
            padding: 4px;
            top: 0;
            left: 0;
            bottom: 0;
            width: 52px;
            border-radius: 26px;
            color: #fff;
            background-color: #073DBE;
            background-clip: content-box;
            cursor: pointer;
            font-size: 24px;
            display: flex;
            justify-content: center;
            align-items: center;
            &::after {
              content: '>>';
              color: #fff;
              font-size: 14px;
            }
          }
        }
      }
      .center-login-form-margin {
        margin: 60px auto;
      }
    }
    .center-login-link {
      font-size: 18px;
      color: #FFFFFF;
      position: absolute;
      bottom: 80px;
      left: 0;
      right: 0;
      text-align: center;
      cursor: pointer;
    }
    .center-login-footer {
      position: absolute;
      left: 0;
      right: 0;
      text-align: center;
      bottom: 40px;
      text-align: center;
      font-size: 14px;
      color: #999999;
    }
    .center-login-qrcode {
      width: 320px;
      height: 320px;
      margin: 32px auto;
      margin-top: 0;
      background-color: #fff;
      background-clip: content-box;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px;
      border-radius: 4px;
      position: relative;
      overflow: hidden;
      #QRCode {
        height: 100%;
        width: 100%;
        margin: 0 auto;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
        iframe {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0px;
          left: 0px;
        }
      }
      #QRCodedd {
        height: 100%;
        width: 100%;
        margin: 0 auto;
        position: relative;
        iframe {
          background: #fff;
        }
      }
      &[expired] {
        background-color: #FFFFFF;
        opacity: .8;
      }
      .expired-code {
        p {
          font-size: 14px;
          font-weight: 500;
          color: #333333;
          line-height: 20px;
        }
        .refresh-code {
          margin: 0 auto;
          margin-top: 8px;
          width: 98px;
          height: 31px;
          line-height: 31px;
          font-size: 13px;
          color: #FFFFFF;
          background: #00A8FE;
        }
      }
    }
    .qrcode-type {
      position: absolute;
      bottom: 0;
      text-align: center;
      transform: translateX(50%);
      font-size: 18px;
      color: #666666;
      line-height: 25px;
      cursor: pointer;
      margin-bottom: 40px;
      span {
        &[active] {
          color: #FFFFFF;
        }
      }
    }
  }
}

.right-login-container2 {
  width: 100vw;
  height: 100vh;
  position: relative;
  background: url('../../assets/images/login-right-bg.png') center right no-repeat;
  background-size: cover;
  .logo {
    position: absolute;
    left: 60px;
    top: 40px;
    img {
      width: 126px;
    }
  }
  .right-login-content-blur {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    // filter: blur(6px);
    // background-color: #d0d4d8;
    background-color: #B6B9C2;
    opacity: 0.5;
    background-repeat: no-repeat;
    background-position: center right;
    background-attachment: fixed;
    // background-size: cover;
  }
  .right-login-content {
    height: 100vh;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 684px;
    display: flex;
    align-items: center;
    justify-content: center;
    .right-login-box {
      position: absolute;
      width: 450px;
      min-height: 70vh;
      // right: 104px;
      background-color: #fff;
      border-radius: 6px;
      padding: 0 32px;
      border: 1px solid;
      border-color: #FFFFFF;
      .right-login-scan {
        position: absolute;
        right: 0px;
        top: 0px;
        width: 54px;
        height: 54px;
        cursor: pointer;
        .icon {
          color: #C8291D;
          font-size: 54px;
        }
      }
      .scan-tag {
        display: inline-block;
        position: absolute;
        right: 20px;
        top: 16px;
        width: 68px;
        height: 68px;
        transform: rotate(45deg);
        background-color: #FFFFFF;
      }
      .right-login-title {
        margin-top: 55px;
        margin-top: 0.386458rem;
        text-align: center;
        font-size: 36px;
        // font-weight: 800;
        color: #333333;
        line-height: 1;
      }
      .right-login-form {
        .right-login-form-title {
          display: flex;
          margin-top: 48px;
          margin-bottom: 16px;
          font-size: 20px;
          color: #333333;
          align-items: center;
          .icon {
            flex: 0 0 46px;
            text-align: center;
            cursor: pointer;
            margin-top: -2px;
          }
          small {
            flex: 1;
            padding-left: 12px;
            font-size: 20px;
            font-weight: 400;
            color: #999999;
            vertical-align: middle;
          }
        }
        .right-login-form-input {
          width: 100%;
          background-color: #FCFCFC;
          border: 1px solid;
          border-color: #dddddd;
          border-radius: 4px;
          display: flex;
          align-items: center;
          height: 54px;
          margin-bottom: 24px;
          padding-right: 16px;
          .input-icon {
            color: #666666;
            padding: 0 16px;
            .icon {
              font-size: 20px;
            }
            .ivu-icon {
              font-weight: bold;
              font-size: 24px !important;
            }
          }
          .input-self {
            flex: 1;
            border: none;
            outline: none;
            box-shadow: none;
            background-color: transparent;
            font-size: 18px;
            line-height: 28px;
            color: #333333;
            min-width: 100px;
            &::-webkit-input-placeholder {
              color: #999;
            }
            &::-moz-placeholder {
              color: #999;
            }
            .default {
              color: #7F7F7F;
            }
          }
        }
        .forget-password {
          text-align: right;
          font-size: 16px;
          font-weight: 400;
          color: #C8291D;
          line-height: 1;
          margin-bottom: 24px;
          cursor: pointer;
        }
        .right-login-button {
          box-shadow: none;
          background-color: #C8291D;
          width: 100%;
          height: 54px;
          border-radius: 4px;
          line-height: 54px;
          font-size: 18px;
          color: #FFFFFF;
          cursor: pointer;
        }
        .special-button {
          margin-bottom: 70px;
          // 输入框边框颜色
          background-color: #C8291D;
          position: relative;
          transition: 1s all;
          user-select: none;
          border-radius: 4px;
          // 字体颜色
          color: #FFFFFF;
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 54px;
          overflow: hidden;
          &.success{
            background-color: #dddddd;
            color: #fff;
          }
          .special-button-block {
            position: absolute;
            z-index: 99;
            padding: 4px;
            top: 0;
            left: 0;
            bottom: 0;
            width: 52px;
            border-radius: 6px;
            color: #fff;
            background-color: #dddddd;
            background-clip: content-box;
            cursor: pointer;
            font-size: 24px;
            display: flex;
            justify-content: center;
            align-items: center;
            &::after {
              content: '>>';
              color: #fff;
              font-size: 14px;
            }
          }
        }
      }
    }
    .right-login-box-padding {
      padding: 0;
    }
  }
  .right-login-link {
    font-size: 18px;
    color: #C8291D;
    position: absolute;
    bottom: 80px;
    left: 0;
    right: 0;
    text-align: center;
    cursor: pointer;
  }
  .right-login-footer {
    cursor: pointer;
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    bottom: 40px;
    text-align: center;
    font-size: 14px;
    color: #999999;
  }
  .right-login-qrcode {
    // width: 405px;
    height: 435px;
    margin: 12px auto;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    #QRCode {
      height: 100%;
      width: 100%;
      margin: 0 auto;
      position: relative;
      iframe {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0px;
        left: 0px;
      }
    }
    #QRCodedd {
      height: 100%;
      width: 100%;
      margin: 0 auto;
      position: relative;
      text-align: center;
    }
    &[expired] {
      background-color: #FFFFFF;
      opacity: .8;
    }
    .expired-code {
      p {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
      }
      .refresh-code {
        margin: 0 auto;
        margin-top: 8px;
        width: 98px;
        height: 31px;
        line-height: 31px;
        font-size: 13px;
        color: #FFFFFF;
        background: #C8291D;
      }
    }
  }
  .qrcode-type {
    text-align: center;
    font-size: 18px;
    color: #666666;
    line-height: 25px;
    cursor: pointer;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 24px;
    span {
      &[active] {
        color: #C12522;
      }
    }
  }
}
// .right-login-container {
//   width: 100%;
//   height: 100%;
//   background: url('../../assets/images/login-right-bg.png') center center no-repeat;
//   background-size: cover;
//   .right-login-content {
//     width: 1400px;
//     height: 100vh;
//     position: relative;
//     left: 50%;
//     margin-left: -700px;
//     display: flex;
//     align-items: center;
//     .logo {
//       position: absolute;
//       left: 0;
//       top: 40px;
//       img {
//         width: 96px;
//       }
//     }
//     .right-login-box {
//       position: absolute;
//       width: 484px;
//       min-height: 486px;
//       right: 0;
//       background-color: #fff;
//       border-radius: 6px;
//       padding: 0 32px;
//       border: 1px solid;
//       border-color: #FFFFFF;
//       .right-login-scan {
//         position: absolute;
//         right: 0px;
//         top: 0px;
//         width: 54px;
//         height: 54px;
//         cursor: pointer;
//         .icon {
//           color: #C8291D;
//           font-size: 54px;
//         }
//       }
//       .scan-tag {
//         display: inline-block;
//         position: absolute;
//         right: 20px;
//         top: 16px;
//         width: 68px;
//         height: 68px;
//         transform: rotate(45deg);
//         background-color: #FFFFFF;
//       }
//       .right-login-title {
//         position: absolute;
//         left: 0;
//         right: 0;
//         text-align: center;
//         top: -86px;
//         font-size: 40px;
//         font-weight: 600;
//         color: #333333;
//         line-height: 1;
//       }
//       .right-login-form {
//         .right-login-form-title {
//           display: flex;
//           margin-top: 48px;
//           margin-bottom: 32px;
//           font-size: 26px;
//           color: #333333;
//           line-height: 37px;
//           .icon {
//             flex: 0 0 46px;
//             text-align: center;
//             line-height: 37px;
//             cursor: pointer;
//           }
//           small {
//             flex: 1;
//             padding-left: 12px;
//             font-size: 20px;
//             font-weight: 400;
//             color: #999999;
//           }
//         }
//         .right-login-form-input {
//           width: 100%;
//           background-color: #FCFCFC;
//           border: 1px solid;
//           border-color: #dddddd;
//           border-radius: 4px;
//           display: flex;
//           align-items: center;
//           height: 54px;
//           margin-bottom: 24px;
//           padding-right: 16px;
//           .input-icon {
//             color: #666666;
//             padding: 0 16px;
//           }
//           .input-self {
//             flex: 1;
//             border: none;
//             outline: none;
//             box-shadow: none;
//             background-color: transparent;
//             font-size: 20px;
//             line-height: 28px;
//             color: #333333;
//             .default {
//               color: #7F7F7F;
//             }
//           }
//         }
//         .forget-password {
//           text-align: right;
//           font-size: 20px;
//           font-weight: 400;
//           color: #C8291D;
//           line-height: 1;
//           margin-bottom: 24px;
//           cursor: pointer;
//         }
//         .right-login-button {
//           box-shadow: none;
//           background-color: #C8291D;
//           width: 100%;
//           height: 54px;
//           border-radius: 4px;
//           line-height: 54px;
//           font-size: 22px;
//           color: #FFFFFF;
//           cursor: pointer;
//         }
//         .special-button {
//           margin-bottom: 70px;
//           // 输入框边框颜色
//           background-color: #C8291D;
//           position: relative;
//           transition: 1s all;
//           user-select: none;
//           // 字体颜色
//           color: #FFFFFF;
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           height: 54px; /*no*/
//           &.success{
//             background-color: #dddddd;
//             color: #fff;
//           }
//           .special-button-block {
//             position: absolute;
//             padding: 4px;
//             top: 0;
//             left: 0;
//             bottom: 0;
//             width: 52px;
//             color: #fff;
//             background-color: #dddddd;
//             background-clip: content-box;
//             cursor: pointer;
//             font-size: 24px;
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             &::after {
//               content: '>>';
//               color: #fff;
//               font-size: 14px;
//             }
//           }
//         }
//       }
//     }
//   }
//   .right-login-link {
//     font-size: 18px;
//     color: #C8291D;
//     position: absolute;
//     bottom: 80px;
//     left: 0;
//     right: 0;
//     text-align: center;
//     cursor: pointer;
//   }
//   .right-login-footer {
//     position: absolute;
//     left: 0;
//     right: 0;
//     text-align: center;
//     bottom: 40px;
//     text-align: center;
//     font-size: 14px;
//     color: #999999;
//   }
//   .right-login-qrcode {
//     width: 300px;
//     height: 300px;
//     margin: 48px auto;
//     background-color: #fff;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     #QRCode {
//       height: 100%;
//       width: 100%;
//       margin: 0 auto;
//       position: relative;
//       iframe {
//         position: absolute;
//         width: 100%;
//         height: 100%;
//         top: 0px;
//         left: 0px;
//       }
//     }
//     #QRCodedd {
//       height: 100%;
//       width: 100%;
//       margin: 0 auto;
//       position: relative;
//       margin-top: -70px;
//     }
//     &[expired] {
//       background-color: #FFFFFF;
//       opacity: .8;
//     }
//     .expired-code {
//       p {
//         font-size: 14px;
//         font-weight: 500;
//         color: #333333;
//         line-height: 20px;
//       }
//       .refresh-code {
//         margin: 0 auto;
//         margin-top: 8px;
//         width: 98px;
//         height: 31px;
//         line-height: 31px;
//         font-size: 13px;
//         color: #FFFFFF;
//         background: #C8291D;
//       }
//     }
//   }
//   .qrcode-type {
//     text-align: center;
//     font-size: 18px;
//     color: #666666;
//     line-height: 25px;
//     cursor: pointer;
//     position: absolute;
//     left: 0;
//     right: 0;
//     bottom: 12px;
//     span {
//       &[active] {
//         color: #C12522;
//       }
//     }
//   }
// }
</style>
